<div class="create-order-progress-tracker-container">
    <div class="refresh-btn-container">
        <span>Orders</span>
        <button 
            pButton 
            class="p-button-secondary p-button-outlined p-button-sm" 
            icon="pi pi-refresh"
            (click)="refreshTable()">
        </button>
    </div>
    <div class="progress-tracker-table-container">
        <ag-grid-angular 
            class="ag-theme-balham" 
            *ngIf="isGridReady" 
            [rowData]="gridData | async"
            [domLayout]="'autoHeight'" 
            [gridOptions]="gridOptions" 
            [pagination]="true" 
            [suppressPaginationPanel]="true"
            (gridReady)="onInitializeGrid($event)">
        </ag-grid-angular>
        <cv-grid-pagination 
            *ngIf="isGridReady" 
            [pagination]="pagination"
            (onPaginationChange)="onPaginationChange($event)">
        </cv-grid-pagination>
    </div>
</div>